import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";

import Button from "../../../../components/button/Button";
import {
  useAddBillingContentMutation,
  useGetBillingContentQuery,
  useUpdateBillingContentMutation,
} from "../../../../services/BillingService";
import { getLinkedFirm } from "../../../../sessionStorage/sessionStorage";
import { SettingsIconButton } from "../../../../components/button/SettingsIconButton";
import { ChevronLeft } from "baseui/icon";
import { useNavigate } from "react-router-dom";

export const BillingContent = () => {
  const navigate = useNavigate();

  const { data: content } = useGetBillingContentQuery(
    getLinkedFirm()?.orgId || "",
  );
  const [editContent] = useUpdateBillingContentMutation();
  const [addContent] = useAddBillingContentMutation();

  const [notes, setNotes] = useState(content?.notes || "");
  const [footer, setFooter] = useState(content?.footer || "");

  useEffect(() => {
    if (content) {
      setNotes(content.notes);
      setFooter(content.footer);
    }
  }, [content]);

  return (
    <div>
      <div
        className={"my-6 flex items-center justify-between gap-4 font-Manrope"}>
        <div className={"flex items-center gap-2"}>
          <SettingsIconButton
            hasShadow={false}
            icon={<ChevronLeft />}
            onClick={() => navigate(-1)}
          />
          <div className={"text-2xl font-semibold"}>Notes & Footer</div>
        </div>
      </div>
      <div className={"flex flex-col gap-6"}>
        <div className={"flex flex-col gap-4"}>
          <div className={"text-sm font-bold"}>Add note to customer</div>
          <textarea
            className={"input input-bordered min-h-[150px] w-[30%]"}
            value={notes || ""}
            placeholder={
              "Thank you for your business. We look forward to serving you again"
            }
            onChange={(e) => setNotes(e.target.value)}
          />
          <div className={"text-sm font-semibold"}>
            (This message will appear on all invoices)
          </div>
        </div>
        <div className={"flex flex-col gap-4"}>
          <div className={"text-sm font-bold"}>Add footer</div>
          <textarea
            className={"input input-bordered min-h-[150px] w-[30%] flex-wrap"}
            value={footer || ""}
            placeholder={
              "Here you can add your sales tax number or let your clients know how they can pay their invoice."
            }
            onChange={(e) => setFooter(e.target.value)}
          />
        </div>
        <Button
          label={"Save"}
          disabled={
            !content
              ? notes === "" && footer === ""
              : content.footer === footer && content.notes === notes
          }
          buttonType={"button"}
          onClick={() => {
            const orgId = getLinkedFirm()?.orgId || "";
            if (content && content.id) {
              editContent({
                notes: notes,
                footer: footer,
                orgId,
                id: content.id,
              })
                .unwrap()
                .then(() => toast.success("Billing content updated"))
                .catch(() => toast.error("Failed to update billing content"));
            } else {
              addContent({
                notes: notes,
                footer: footer,
                orgId,
              })
                .unwrap()
                .then(() => toast.success("Billing content added"))
                .catch(() => toast.error("Failed to add billing content"));
            }
          }}
        />
      </div>
    </div>
  );
};
